
// should display a duration with the format min:sec
export function formatSecondsToMinutes(duration: number): string {
	return `${Math.floor(duration / 60)}:${Math.floor(duration % 60) < 10 ? '0' : ''}${Math.floor(duration % 60)}`;
}
